import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import image1 from './images/traditional-hot-chocolate.png'
import image2 from './images/nutella-hot-chocolate.png'
import image3 from './images/hot-chocolate-brownie.png'
import './menu.css'
import NavigationBar from './nav';
import NewNav from './canvas';
import Aos from 'aos';
import "aos/dist/aos.css";
import { useEffect } from 'react';

function Hotchocolate() {
  const products = [
    { id: 1, name: "Traditional Hot Chocolate", image: image1 },
    { id: 2, name: "Nutella Hot Chocolate", image: image2 },
    { id: 3, name: "Hot Chocolate with Brownie", image: image3 },
  ]
  useEffect(() => {
      Aos.init({ duration: "1000" })
    })
  return (
    <>
    <Container fluid>
              <Row>
              <NavigationBar/>
              <NewNav/>
                <Col id='rockTop'>  
                <Row>
                  <Col id='rockHeading'>
                  <p data-aos="zoom-in">Hot Chocolate</p>
                  </Col>
                </Row>
                </Col>
              </Row>
            </Container>
      <Container>
        <Row>
          <Col md={12} style={{justifyContent: "center",gap: "20px"}}>
            <Row>
              {products.map((p)=>(
              <Col xs={4} md={3} key={products.id} style={{ marginTop: "20px",textAlign:"center",gap:"20px"}}>
                <Card data-aos="zoom-in" style={{border:"none"}}>
                  <Card.Img id='hotcImg'
                  src={p.image} />
                  <Card.Body>
                    <Card.Title id='cardName'>{p.name}</Card.Title>
                  </Card.Body>
                </Card>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Hotchocolate